// helpers
import { appSection } from "../../utils/panel-helpers/helpers";
import ApiHelper from "../../utils/apiHelper";
// actions
import { globalActionCreators } from "./globalModule";

export const settingsActionTypes = {
  SET_SETTINGS_DATA: "SET_SETTINGS_DATA"
};

export const initialState = {
  hotelSettingsData: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case settingsActionTypes.SET_SETTINGS_DATA:
      return {
        ...state,
        hotelSettingsData: action.hotelSettingsData
      };
    default:
      return state;
  }
};

export const settingsActionCreators = {
  loadHotelSettingsAction: (hotelId, callSectionLoader) => async (dispatch, getState) => {
    const sectionLoadingNamesState = getState().global.sectionLoadingNames;
    if (sectionLoadingNamesState?.includes(appSection?.hotelSettings)) {
      // disable new API call if we are still waiting for response
      return;
    }
    const isHotelGroupExistsState = getState().home.isHotelGroupExists;
    const hotelIdParam = isHotelGroupExistsState && hotelId ? `?hotelId=${hotelId}` : "";

    const sectionUrl = appSection?.hotelSettings;

    callSectionLoader(true, sectionUrl);

    try {
      const res = await ApiHelper.get(`/v1/settings${hotelIdParam}`);

      dispatch({
        type: settingsActionTypes.SET_SETTINGS_DATA,
        hotelSettingsData: res.data
      });
    } catch (error) {
      dispatch(globalActionCreators.handleErrorAction());
    } finally {
      callSectionLoader(false, sectionUrl);
    }
  },
  updateSettingsAction:
    (
      name,
      website,
      email,
      street,
      streetNumber,
      zipCode,
      city,
      phone,
      contactPerson,
      costCenterMandatory,
      referenceMandatory,
      onHandleFormMessage,
      onLoadSettings
    ) =>
    async (dispatch, getState) => {
      const isHotelGroupExistsState = getState().home.isHotelGroupExists;
      const selectedHotelsState = getState().global.selectedHotels;

      try {
        let bodyFormData = {
          name: name,
          email: email,
          address: {
            street: street,
            houseNumber: streetNumber,
            zipCode: zipCode,
            city: city,
            phoneNumber: phone
          },
          accountSettings: getState().home?.accountSettingsData,
          website: website
        };

        if (isHotelGroupExistsState) {
          bodyFormData = {
            ...bodyFormData,
            hotelId: selectedHotelsState[0]?.id
          };
        }

        const res = await ApiHelper.post(`/v2/settings/edit`, {}, JSON.stringify(bodyFormData));

        isHotelGroupExistsState ? onLoadSettings(selectedHotelsState[0]?.id) : onLoadSettings();
        onHandleFormMessage(res.data.status, "Settings");
      } catch (error) {
        console.log(error);
      }
    }
};
